import React, { useState } from 'react';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { PLATFORM_DIMENSIONS } from '../../helpers/socialContentService';

const TemplateForm = ({ initialData, onSubmit, onCancel }) => {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        html: '',
        css: '',
        platform: 'instagram',
        type: 'post',
        variables: {},
        ...initialData
    });

    const [newVariable, setNewVariable] = useState({
        name: '',
        type: 'string',
        description: '',
        required: false
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePlatformTypeChange = (e) => {
        const { name, value } = e.target;
        const dimensions = PLATFORM_DIMENSIONS[formData.platform]?.[value] ||
            PLATFORM_DIMENSIONS[value]?.[formData.type];

        setFormData(prev => ({
            ...prev,
            [name]: value,
            dimensions: dimensions || prev.dimensions
        }));
    };

    const handleAddVariable = () => {
        if (!newVariable.name || !newVariable.description) return;

        setFormData(prev => ({
            ...prev,
            variables: {
                ...prev.variables,
                [newVariable.name]: {
                    type: newVariable.type,
                    description: newVariable.description,
                    required: newVariable.required
                }
            }
        }));

        setNewVariable({
            name: '',
            type: 'string',
            description: '',
            required: false
        });
    };

    const handleRemoveVariable = (variableName) => {
        const newVariables = { ...formData.variables };
        delete newVariables[variableName];

        setFormData(prev => ({
            ...prev,
            variables: newVariables
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Nombre
                    </label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                        required
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Descripción
                    </label>
                    <input
                        type="text"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                        required
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Plataforma
                    </label>
                    <select
                        name="platform"
                        value={formData.platform}
                        onChange={handlePlatformTypeChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                    >
                        <option value="instagram">Instagram</option>
                        <option value="facebook">Facebook</option>
                        <option value="linkedin">LinkedIn</option>
                        <option value="twitter">Twitter</option>
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Tipo
                    </label>
                    <select
                        name="type"
                        value={formData.type}
                        onChange={handlePlatformTypeChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                    >
                        <option value="post">Post</option>
                        <option value="story">Story</option>
                        <option value="carousel">Carousel</option>
                    </select>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        HTML
                    </label>
                    <textarea
                        name="html"
                        value={formData.html}
                        onChange={handleChange}
                        rows={10}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm font-mono"
                        required
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        CSS
                    </label>
                    <textarea
                        name="css"
                        value={formData.css}
                        onChange={handleChange}
                        rows={10}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm font-mono"
                        required
                    />
                </div>
            </div>

            <div className="space-y-4">
                <h3 className="text-lg font-medium text-gray-900">Variables</h3>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <input
                        type="text"
                        placeholder="Nombre"
                        value={newVariable.name}
                        onChange={(e) => setNewVariable(prev => ({ ...prev, name: e.target.value }))}
                        className="rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                    />

                    <select
                        value={newVariable.type}
                        onChange={(e) => setNewVariable(prev => ({ ...prev, type: e.target.value }))}
                        className="rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                    >
                        <option value="string">Texto</option>
                        <option value="number">Número</option>
                    </select>

                    <input
                        type="text"
                        placeholder="Descripción"
                        value={newVariable.description}
                        onChange={(e) => setNewVariable(prev => ({ ...prev, description: e.target.value }))}
                        className="rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                    />

                    <div className="flex items-center space-x-4">
                        <label className="flex items-center space-x-2">
                            <input
                                type="checkbox"
                                checked={newVariable.required}
                                onChange={(e) => setNewVariable(prev => ({ ...prev, required: e.target.checked }))}
                                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                            />
                            <span className="text-sm text-gray-600">Requerido</span>
                        </label>

                        <button
                            type="button"
                            onClick={handleAddVariable}
                            className="flex items-center space-x-1 px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600"
                        >
                            <FaPlus size={12} />
                            <span>Añadir</span>
                        </button>
                    </div>
                </div>

                <div className="space-y-2">
                    {Object.entries(formData.variables).map(([name, config]) => (
                        <div key={name} className="flex items-center justify-between bg-gray-50 p-3 rounded">
                            <div>
                                <span className="font-medium">{name}</span>
                                <span className="mx-2 text-gray-400">|</span>
                                <span className="text-sm text-gray-600">{config.description}</span>
                                {config.required && (
                                    <span className="ml-2 text-red-500 text-sm">*</span>
                                )}
                            </div>
                            <button
                                type="button"
                                onClick={() => handleRemoveVariable(name)}
                                className="text-red-500 hover:text-red-600"
                            >
                                <FaTrash />
                            </button>
                        </div>
                    ))}
                </div>
            </div>

            <div className="flex justify-end space-x-4">
                <button
                    type="button"
                    onClick={onCancel}
                    className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                    Cancelar
                </button>
                <button
                    type="submit"
                    className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                    {initialData ? 'Actualizar' : 'Crear'} Plantilla
                </button>
            </div>
        </form>
    );
};

export default TemplateForm; 